import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

import HomeView from '@/views/HomeView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import SairView from '@/views/SairView.vue'

import AdmHomeView from '@/views/adm/AdmHomeView.vue'
import AdmUsuariosView from '@/views/adm/AdmUsuariosView.vue'
import AdmTurmasView from '@/views/adm/AdmTurmasView.vue'
import AdmCursosView from '@/views/adm/AdmCursosView.vue'
import AdmTurmasDetalhesView from '@/views/adm/AdmTurmasDetalhesView.vue'
import AdmUploadImg from '@/views/adm/AdmUploadImg.vue'

import ProfessorHomeView from '@/views/professor/HomeView.vue'
import PlanosView from '@/views/professor/PlanosView.vue'
import PlanosEditarView from '@/views/professor/PlanosEditarView.vue'
import NotasView from '@/views/professor/NotasView.vue'
import LembretesView from '@/views/professor/LembretesView.vue'
import NotacoesView from '@/views/professor/notacoes/NotacoesView.vue'
import GruposView from '@/views/professor/GruposView.vue'
import GruposEditarView from '@/views/professor/GruposEditarView.vue'
import GruposExibirView from '@/views/professor/grupos/GruposExibirView.vue'
import TurmaView from '@/views/professor/TurmaView.vue'
import ElaborarParecerView from '@/views/professor/NotacoesElaborarParecerView.vue'
import CriarQuestoesView from '@/views/professor/CriarQuestoesView.vue'
import RecursosDidaticosView from '@/views/professor/RecursosDidaticosView.vue'
import GoogleView from '@/views/professor/GoogleView.vue'
import CadernoTurmaView from '@/views/professor/caderno/CadernoTurmaView.vue'
import ResumoDesempenhoView from '@/views/professor/ResumoDesempenhoView.vue'


import EstudanteHomeView from '@/views/estudante/EstudanteHomeView.vue'
import AvaliacaoView from '@/views/estudante/AvaliacaoView.vue'
import AulasView from '@/views/estudante/AulasView.vue'
import AulaView from '@/views/estudante/AulaView.vue'
import ConteudoView from '@/views/estudante/ConteudoView.vue'
import GruposEstudanteView from '@/views/estudante/GruposEstudanteView.vue'
import ParecerPrimeiroTri from '@/views/estudante/ParecerPrimeiroTri.vue'
import CadernoView from '@/views/estudante/CadernoView.vue'
import MensagemTeamsView from '@/views/professor/planos/MensagemTeamsView.vue'
import DesempenhoGeralAlunosView from '@/views/professor/relatorios/DesempenhoGeralAlunosView.vue'
import LoginGoogleView from '@/views/LoginGoogleView.vue'





const routes = [
  
  { path: '/login-google', name: 'login-google', component: LoginGoogleView },
  { path: '/', name: 'home', component: HomeView },
  { path: '/sair', name: 'sair', component: SairView },
  { path: '/administrador', name: 'administrador', component: AdmHomeView, 
    children: [
      { path: 'usuarios', component: AdmUsuariosView, meta: { keepAlive: false } },
      { path: 'turmas', component: AdmTurmasView, meta: { keepAlive: true } },
      { path: 'turmas/:id', name: 'turmaDetalhe', component: AdmTurmasDetalhesView, meta: { keepAlive: false } },
      { path: 'cursos', component: AdmCursosView, meta: { keepAlive: false } },
      { path: 'uploadimg', component: AdmUploadImg, meta: { keepAlive: false } }
      ]
  },
  { path: '/professor', name: 'professor', component: ProfessorHomeView},
  {
    path: '/professor/turma/',
    name: 'turma',
    component: TurmaView,
    children: [
      { path: 'planos', name: 'planos', component: PlanosView},
      { path: 'notas', name: 'notas', component: NotasView },
      { path: 'lembretes', neme: 'lembretes', component: LembretesView },
      { path: 'notacoes', name: 'notacoes', component: NotacoesView },
      { path: 'grupos', name: 'grupos', component: GruposView },
      { path: 'caderno', name: 'caderno', component: CadernoTurmaView }
    ],
    
  },
  { path: '/professor/turma/planos/editar', name: 'AdicionarPlano', component: PlanosEditarView },
  { path: '/professor/turma/grupos/editar', name: 'AdicionarGrupo', component: GruposEditarView },
  { path: '/professor/turma/grupos/exibir', name: 'ExibirGrupo', component: GruposExibirView},
  { path: '/professor/elaborar-parecer', name: "ElaborarParecer", component: ElaborarParecerView },
  { path: '/professor/criar-questoes', name: "CriarQuestoes", component: CriarQuestoesView },
  { path: '/professor/recursos-didaticos', name: "RecursosDidaticos", component: RecursosDidaticosView },
  {path: '/professor/resumo-desempenho', name: 'ResumoDesempenho', component: ResumoDesempenhoView},
  { path: '/professor/google',  component: GoogleView },
  { path: '/professor/mensagem-teams', component: MensagemTeamsView },
  {path: '/professor/desempenho-alunos-geral', component: DesempenhoGeralAlunosView},
  
  
  
  // Estudante
  { path: '/estudante', name: 'estudante', component: EstudanteHomeView },
  { path: '/estudante/aulas/', name: 'aulas', component: AulasView  },
  { path: '/estudante/parecer/', name: 'parecer-primeiro-tri', component: ParecerPrimeiroTri },
  { path: '/estudante/aula/', name: 'aula', component: AulaView,
    children: [
      { path: 'avaliacao', component: AvaliacaoView },
      { path: 'conteudo', component: ConteudoView },
      { path: 'grupos', component: GruposEstudanteView },
      { path: 'caderno', component: CadernoView }
    ]},


  // Outras
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView }

 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  
  const userSession = store.state.userSession;

  if (to.path == "/login-google"){
    next();
    return;
  }

  // Redireciona para a página inicial se o usuário não estiver logado
  if (!userSession) {
    if (to.name !== 'home') {
      next({ name: 'home' });
    } else {
      next();
    }
    return;
  }

  // Permite o acesso à rota "sair"
  if (to.name === "sair") {
    next();
    return;
  }

  const userRole = userSession.user.funcao;

  // Redireciona para a página do role do usuário se estiver tentando acessar a home
  if (to.name === 'home') {
    next({ name: userRole });
    return;
  }

  // Verifica se a rota atual ou suas filhas correspondem ao userRole
  if (to.matched.some(record => routeOrChildMatchesRole(record, userRole))) {
    next();
  } else {
    // Verifica se está tentando acessar uma sub-rota permitida
    if (to.path.startsWith(`/${userRole}`)) {
      next();
    } else {
      next({ name: userRole });
    }
  }
});




function routeOrChildMatchesRole(route, role) {
  // Verifica se a rota atual corresponde ao role
  if (route.name === role) {
    return true;
  }

  // Verifica as rotas filhas (se houver)
  if (route.children && route.children.length) {
    return route.children.some(childRoute => childRoute.name === role || routeOrChildMatchesRole(childRoute, role));
  }

  return false;
}




export default router
